var _path, _line, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDistalHinge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6543 24.9687C16.7819 24.9896 16.9043 25 17.0266 25C17.9681 25 18.766 24.3419 18.9894 23.4384C19.7766 20.2317 22 12.5649 22 10.5803C22 8.0525 19.9096 6 17.3351 6C16.6809 6 16.0585 6.13057 15.4947 6.37081C15.0213 6.56927 14.5106 6.67372 14 6.67372C13.4894 6.67372 12.9787 6.57449 12.5053 6.37081C11.9415 6.13057 11.3191 6 10.6649 6C8.09043 6 6 8.0525 6 10.5803C6 12.3194 8.20213 20.2317 8.9734 23.4384C9.19149 24.3419 9.98936 25 10.9362 25C11.0585 25 11.1862 24.9896 11.3138 24.9634C12.2713 24.7859 12.9362 23.9241 12.9362 22.9684V20.7905C12.9362 19.9601 13.4043 19.5006 13.984 19.5006C14.5638 19.5006 15.0319 19.9601 15.0319 20.5294V22.9684C15.0319 23.9241 15.6968 24.7911 16.6596 24.9687H16.6543Z",
    fill: "#707070"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 4,
    x2: 6.5,
    y2: 27,
    stroke: "white",
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00068 19.1699L13.1248 16.5096L12.8666 22.2773L8.00068 19.1699ZM21.8517 9.52239C22.0914 9.44791 22.3345 9.4941 22.5208 9.55612C22.7186 9.62196 22.923 9.72935 23.1223 9.85956C23.5225 10.1209 23.9568 10.5099 24.3557 10.9773C25.1438 11.9008 25.8737 13.2272 25.8418 14.6166C25.8086 16.0669 24.9521 17.4387 22.8724 18.4022C20.822 19.3522 17.5362 19.9353 12.492 19.8712L12.5047 18.8713C17.495 18.9347 20.6032 18.3515 22.452 17.4949C24.2715 16.6519 24.8196 15.5768 24.8421 14.5937C24.866 13.5496 24.3028 12.4559 23.595 11.6265C23.2459 11.2174 22.8815 10.8967 22.5755 10.6968C22.4217 10.5964 22.2961 10.5353 22.205 10.5049C22.1024 10.4708 22.0976 10.4931 22.1483 10.4774L21.8517 9.52239Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDistalHinge);
export default __webpack_public_path__ + "static/media/Icon_Distal_Hinge.1e598e0aa179b52528e2126bf03f0944.svg";
export { ForwardRef as ReactComponent };